export default "__VITE_ASSET__Cc$fQ$PT__"